<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SMJdM6/tc-custom/9781684127740.jpg?1738763168422" alt="This image is the cover for the book Presidential Inaugural Addresses, Word Cloud Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Presidential Inaugural Addresses, Word Cloud Classics
      </h1>
      <p class="bookDescription body article font2">
        <p><b>America’s evolution across the centuries is captured in this volume of speeches delivered by each president upon being sworn into office.</b></p> This book presents every inaugural address delivered by every American president from George Washington to Donald Trump. With immortal quotes such as Thomas Jefferson’s “Every difference of opinion is not a difference of principle” and John F. Kennedy’s “Ask not what your country can do for you,” you’ll find the speeches that have inspired, united, and fired up the American population as our nation’s leaders embark on their service to the public. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Editors of Canterbury Classics
      </h2>
      
      <p class="authorDescription body article">Canterbury Classics is an imprint of Printers Row Publishing Group, a wholly owned subsidiary of Readerlink Distribution Services, LLC, the largest full-service book distributor to non-trade booksellers in North America. Canterbury Classics publishes classic works of literature in fresh, modern formats. From elegant leather-bound editions to whimsical pop-up books to the best-selling Word Cloud Classics series and more, our extensive collection is sure to captivate and inspire readers and brighten bookshelves.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Cloud Classics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf76bec2